import { ApiEndPoints, NetworkManager } from "../network";

export class AshaAbstractReportService{
    static getAll = () => {
      return NetworkManager.getInstance().appRequest({
        method: "get",
        url: ApiEndPoints.getAshaAbstractReport
      });
    };
    static getByAshaId = (ashaId) => {
      return NetworkManager.getInstance().appRequest({
        method: "get",
        url: ApiEndPoints.getAshaAbstractReport + "/byAshaId/" + ashaId
      });
    };
    static getByPhcId = (phcId) => {
      return NetworkManager.getInstance().appRequest({
        method: "get",
        url: ApiEndPoints.getAshaAbstractReport + "/byPhcId/" + phcId
      });
    };
    static getByTalukId = (talukId) => {
      return NetworkManager.getInstance().appRequest({
        method: "get",
        url: ApiEndPoints.getAshaAbstractReport + "/byTalukId/" + talukId
      });
    };
    static getByAshaBlockId = (ashaBlockId) => {
      return NetworkManager.getInstance().appRequest({
        method: "get",
        url: ApiEndPoints.getAshaAbstractReport + "/byAshaBlockId/" + ashaBlockId
      });
    };
    static getSuperAdmin = () => {
      return NetworkManager.getInstance().appRequest({
        method: "get",
        url: ApiEndPoints.getAshaAbstractReport + "/super-admin"
      });
    };
    static create = (reportData) => {
      return NetworkManager.getInstance().appRequest({
        method: "post",
        url: ApiEndPoints.getAshaAbstractReport,
        data: reportData
      });
    };
    static update = (reportData) => {
      return NetworkManager.getInstance().appRequest({
        method: "put",
        url: ApiEndPoints.getAshaAbstractReport,
        data: reportData
      });
    };
    static delete = (id) => {
      return NetworkManager.getInstance().appRequest({
        method: "delete",
        url: ApiEndPoints.getAshaAbstractReport + "/" + id
      });
    };

  
}
